import style from './displayEmoji.module.css';

const animations = `${style.hWave}, ${style.vUp}`;
/*
const animations = `${style.hWave}, ${style.tilt}, ${style.vUp}`;
const animations = `${style.hWave}, ${style.tilt}`;
const animations = `${style.hWave}`;
const animations = `${style.vUp}`;
*/

const maybeNegative = (value = 1) => (Math.random() >= 0.5 ? value : -value);

export class BubbleInstance {
  static completeEvent = 'complete';
  static startEvent = 'start';
  static readyEvent = 'ready';

  /**
   * @type {AnimationItem}
   */
  #lottie;

  #canvasSize;
  #stopped = true;
  /**
   * @type HTMLElement
   */
  container;
  consumable = false;
  #callbacks = [];

  /**
   *
   * @param {LottiePlayer} animationFactory
   * @param {HTMLElement} container
   * @param {string} animationData
   * @param {{width: number, height: number}} [canvasSize={}]
   */
  constructor(animationFactory, container, animationData, canvasSize = {}) {
    this.container = container;
    // this.onResize = animationFactory.resize;
    this.#canvasSize = canvasSize;
    this.#lottie = animationFactory.loadAnimation({
      container: this.container,
      animationData: JSON.parse(animationData),
      loop: true,
      autoplay: false,
      renderer: 'canvas',
    });
    // this.#lottie.setSubframe(false);
    // this.#lottie.addEventListener('data_ready', this.#onDataReady);

    this.container.addEventListener('animationend', this.#onAnimationEnd);
    this.container.addEventListener('animationstart', this.#onAnimationStart);
    // this.container.addEventListener('transitionend', this.onResize);

    // Some kind of dirty trick.
    // try to make life easy for devices
    // animate only first and second emoji
    if (container.dataset.allowAnimation === 'false') {
      this.#lottie.play = Function.prototype;
    }
    this.#lottie.setSubframe(this.#useSubframe());

    // TODO: reorganize DisplayEmoji.registerInstance, then avoid such emitting
    Promise.resolve().then(() => {
      this.consumable = true;
      this.#fireEvent(BubbleInstance.readyEvent);
    });
  }

  set canvasSize(canvasSize) {
    this.#canvasSize = canvasSize;
    this.consumable && this.#lottie.resize();
  }

  /**
   * Set container scale, it should used only when starts bubbling.
   * @param {number} scale
   */
  set scale(scale) {
    this.container.style.setProperty('--scale', scale.toString());
  }

  /*
    /!**
     * .04 per vote, but not great than 2
     * @return {number}
     *!/
    get scale() {
      // return Math.min(2, 1 + this.state.count/25);
      /!* calc bellow expect to grow instance *!/
      return Math.min(2, 1 + this.#count / 25);

      /!* calc below expect to less shrink *!/
      // return Math.max(3-this.count/25, 2);
    }
  */

  get isBubbling() {
    return !this.#stopped;
  }

  set transparent(isTransparent) {
    this.container.style.setProperty('--opacity', isTransparent ? '0.01' : '1');
  }

  set hidden(isHidden) {
    isHidden
      ? this.container.setAttribute('hidden', 'true')
      : this.container.removeAttribute('hidden');
  }

  set animation(animationName) {
    this.container.style.animationName = animationName;
  }

  set animationDelay(animationDelay) {
    this.container.style.setProperty('--animation-delay', `${animationDelay}s`);
  }

  onReady(cb) {
    this.#callbacks.push([BubbleInstance.readyEvent, cb]);
  }

  onStart(cb) {
    this.#callbacks.push([BubbleInstance.startEvent, cb]);
  }

  onComplete(cb) {
    this.#callbacks.push([BubbleInstance.completeEvent, cb]);
  }

  #onDataReady = () => {
    this.#lottie.removeEventListener('data_ready', this.onReady);
    this.#lottie.setSubframe(this.#useSubframe());
    this.consumable = true;
    this.#fireEvent(BubbleInstance.readyEvent);
  };

  /*

    setCount(count, isOwn = false) {
      if (isOwn) {
        this.setOwnCount(count);
      } else {
        this.setExternalCount(count);
      }
    }

    setExternalCount(count) {
      const diff = count - this.#ownCount;
      if (diff > 0) {
        this.#ownCount = 0;
      } else {
        this.#ownCount = this.#ownCount - count;
      }
      log('External count %d, new own: %d', count, this.#ownCount);
      this.applyCount(Math.max(diff, 0));
    }

    setOwnCount(count) {
      this.#ownCount += count;
      log('Own count, new own: %d', this.#ownCount);
      this.applyCount(count);

      this.container.classList.add(style.own);
    }

    applyCount(count) {
      const prevCount = this.#count;
      this.#count += count;

      /!*
          if (prevCount === 0 && this.#count > 0) {
            this.start();
          }
      *!/

      this.#stopped && this.#count > 0 && this.start();

      if (this.#count > prevCount) {
        log('Apply count %d, new #count: %d', count, this.#count);
        // this.container.style.setProperty('--scale', this.scale);
        this.scale = this.scale;
        this.onResize();
      }
    }
  */

  #useSubframe = () => {
    // Prevent lottie attempt to render animation with origin AE fps when it great then 60.
    const frames = this.#lottie.getDuration(true);
    const duration = this.#lottie.getDuration(false);
    const fps = frames / duration;
    const preferSubframe = fps > 60;

    // console.log('Animation. Duration: %d frames / %f seconds. FPS: %f, Use sub frames %s', frames, duration, fps, preferSubframe);

    return preferSubframe;
  };

  destroy() {
    this.container.removeEventListener('animationend', this.onAnimationEnd);
    // this.container.removeEventListener('transitionend', this.onResize);
    this.#lottie.removeEventListener('data_ready', this.onReady);
    this.#lottie.destroy();
    return this.container;
  }

  randomize() {
    const xOffset = Math.random() * this.#canvasSize.width * 0.5;
    // const xOffset = Math.random();
    const tilt = maybeNegative(Math.random() * 35);
    const yOffset = Math.random() * 5;
    const randomLR = maybeNegative();
    const randomXDeviation = maybeNegative(Math.random() * 15);

    this.container.style.setProperty('--tilt', `${tilt}deg`);
    this.container.style.setProperty('--x-offset', `${xOffset}px`);
    this.container.style.setProperty('--y-offset', `-${yOffset}vh`);
    this.container.style.setProperty('--randomLR', `${randomLR}`);
    this.container.style.setProperty(
      '--random-x-deviation',
      `${randomXDeviation}px`,
    );
  }

  /**
   *
   * @param {AnimationEvent} event
   */
  #onAnimationEnd = (event) => {
    if (event.animationName !== style.vUp) {
      return;
    }
    // this.#count = 0;
    this.stop();
  };

  /**
   *
   * @param {AnimationEvent} event
   */
  #onAnimationStart = (event) => {
    if (event.animationName !== style.vUp) {
      return;
    }
    this.transparent = false;
  };

  restart = () => {
    this.transparent = true;
    this.animation = '';
    this.randomize();
    this.animationDelay = Math.random() + 0.2;
    this.#lottie.resize();
    this.animation = animations;
  };

  pause = () => {
    this.hidden = true;
    this.#lottie.pause();
  };
  resume = () => {
    this.hidden = false;
    this.#lottie.play();
  };

  stop = () => {
    this.hidden = true;
    this.#lottie.stop();
    this.animation = '';

    this.container.classList.remove(style.own);

    this.#stopped = true;

    // log('Stop bubbling');

    this.#fireEvent(BubbleInstance.completeEvent);
  };

  start = (scale = 1, { isOwn = false, isOneOfSwarm = false } = {}) => {
    this.randomize();
    this.animationDelay = isOwn ? 0 : isOneOfSwarm ? Math.random() + 0.3 : 0;
    this.scale = scale;
    this.transparent = true;
    this.hidden = false;
    this.#lottie.resize();
    this.#lottie.play();
    if (isOwn) {
      this.container.classList.add(style.own);
    }
    this.animation = animations;

    this.#stopped = false;
    // log('Start bubbling');

    this.#fireEvent(BubbleInstance.startEvent);
  };

  /**
   *
   * @param {string} eventName
   */
  #fireEvent = (eventName) => {
    this.#callbacks
      .filter(([event]) => event === eventName)
      .forEach(([, cb]) =>
        cb({
          event: eventName,
          target: this.container,
        }),
      );
  };
}
